module.exports = __webpack_public_path__ + "img/map10.9de63890.png";